import React, { useEffect, useRef } from "react";
import { Text } from "../Text/Text";
import { Icon } from "../Icon/Icon";
import PropTypes from "prop-types";
import { Tag } from "../Tag/Tag";
import { Tooltip } from "../Tooltip/Tooltip";

export const Defaultcard = ({
    image,
    title,
    description,
    isInfo,
    isComingSoon,
    onClick,
    selected,
    publishing_credits,
    isAIActive,
}) => {
    const svgContainer1 = useRef(null);
    useEffect(() => {
        if (window.lottie && svgContainer1.current) {
            const animItem = window.lottie.loadAnimation({
                container: svgContainer1.current, // Reference to the container div
                renderer: "svg",
                loop: true,
                autoplay: true,
                path: `${process.env.REACT_APP_URL}animations/AILoader.json`,
            });

            return () => {
                if (animItem) {
                    animItem.destroy();
                }
            };
        }
    }, []);

    return (
        <div className="creat-test-card-repeat" onClick={onClick}>
            <div
                className={`create-test-card ${
                    selected ? "selected-card" : ""
                } ${title === "First click" ? "first-click-box" : ""}`}
            >
                <div className="card-placeholder-img">
                    {title === "Card sorting" && (
                        <svg
                            className="card-sorting-placeholder"
                            width="304"
                            height="181"
                            viewBox="0 0 304 181"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect
                                x="0.5"
                                y="0.5"
                                width="303"
                                height="180"
                                rx="9.5"
                                fill="white"
                                stroke="#E9E9E9"
                            />
                            <rect
                                x="15"
                                y="16"
                                width="88.4225"
                                height="17.4789"
                                rx="3.08451"
                                fill="#E9E9E9"
                            />
                            <rect
                                x="112.162"
                                y="16.5141"
                                width="83.2817"
                                height="67.8592"
                                rx="4.62676"
                                fill="#FFEDD9"
                                stroke="#D7A56A"
                                strokeWidth="1.02817"
                                strokeDasharray="2.06 2.06"
                            />
                            <rect
                                x="112.162"
                                y="93.6264"
                                width="83.2817"
                                height="67.8592"
                                rx="4.62676"
                                fill="#F5F5F5"
                                stroke="#CCCCCC"
                                strokeWidth="1.02817"
                                strokeDasharray="2.06 2.06"
                            />
                            <rect
                                x="204.697"
                                y="16.5141"
                                width="83.2817"
                                height="67.8592"
                                rx="4.62676"
                                fill="#F5F5F5"
                                stroke="#CCCCCC"
                                strokeWidth="1.02817"
                                strokeDasharray="2.06 2.06"
                            />
                            <rect
                                x="204.697"
                                y="93.6264"
                                width="83.2817"
                                height="67.8592"
                                rx="4.62676"
                                fill="#F5F5F5"
                                stroke="#CCCCCC"
                                strokeWidth="1.02817"
                                strokeDasharray="2.06 2.06"
                            />
                            <g filter="url(#filter0_d_1396_3893)">
                                <rect
                                    className="change-hover"
                                    x="56.1267"
                                    y="47.2285"
                                    width="88.4225"
                                    height="17.4789"
                                    rx="3.08451"
                                    transform="rotate(-11.6546 56.1267 47.2285)"
                                    fill="white"
                                />
                                <rect
                                    x="56.734"
                                    y="47.6282"
                                    width="87.3944"
                                    height="16.4507"
                                    rx="2.57042"
                                    transform="rotate(-11.6546 56.734 47.6282)"
                                    stroke="black"
                                    strokeWidth="1.02817"
                                />
                            </g>
                            <rect
                                x="15"
                                y="67.4082"
                                width="88.4225"
                                height="17.4789"
                                rx="3.08451"
                                fill="#E9E9E9"
                            />
                            <rect
                                x="15"
                                y="93.1123"
                                width="88.4225"
                                height="17.4789"
                                rx="3.08451"
                                fill="#E9E9E9"
                            />
                            <rect
                                x="119.359"
                                y="59.6967"
                                width="67.8592"
                                height="16.4507"
                                rx="2.57042"
                                fill="white"
                                stroke="#D7A56A"
                                strokeWidth="1.02817"
                                strokeDasharray="2.06 2.06"
                            />
                            <rect
                                x="15"
                                y="118.817"
                                width="88.4225"
                                height="17.4789"
                                rx="3.08451"
                                fill="#E9E9E9"
                            />
                            <rect
                                x="15"
                                y="144.521"
                                width="88.4225"
                                height="17.4789"
                                rx="3.08451"
                                fill="#E9E9E9"
                            />
                            <defs>
                                <filter
                                    id="filter0_d_1396_3893"
                                    x="51.6855"
                                    y="28.9248"
                                    width="99.0127"
                                    height="43.8633"
                                    filterUnits="userSpaceOnUse"
                                    colorInterpolationFilters="sRGB"
                                >
                                    <feFlood
                                        floodOpacity="0"
                                        result="BackgroundImageFix"
                                    />
                                    <feColorMatrix
                                        in="SourceAlpha"
                                        type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                        result="hardAlpha"
                                    />
                                    <feOffset dy="4" />
                                    <feGaussianBlur stdDeviation="2.5" />
                                    <feComposite
                                        in2="hardAlpha"
                                        operator="out"
                                    />
                                    <feColorMatrix
                                        type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                                    />
                                    <feBlend
                                        mode="normal"
                                        in2="BackgroundImageFix"
                                        result="effect1_dropShadow_1396_3893"
                                    />
                                    <feBlend
                                        mode="normal"
                                        in="SourceGraphic"
                                        in2="effect1_dropShadow_1396_3893"
                                        result="shape"
                                    />
                                </filter>
                            </defs>
                        </svg>
                    )}

                    {title === "Preference test" && (
                        <svg
                            className="preference-placeholder"
                            width="304"
                            height="181"
                            viewBox="0 0 304 181"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect
                                x="0.5"
                                y="0.5"
                                width="303"
                                height="180"
                                rx="9.5"
                                fill="white"
                                stroke="#E9E9E9"
                            />
                            <rect
                                x="15"
                                y="16"
                                width="120"
                                height="146"
                                rx="7"
                                fill="#F2F2F2"
                            />
                            <path
                                d="M80.8692 132.207C80.1361 131.433 79.1656 131.009 78.1297 131.009C77.0939 131.009 76.1204 131.436 75.3873 132.21L75.0045 132.614L74.6156 132.204C73.8826 131.429 72.9061 131 71.8703 131C70.8344 131 69.8639 131.426 69.1338 132.197C68.4007 132.972 67.997 134 68 135.094C68 136.188 68.4066 137.213 69.1397 137.987L74.7136 143.875C74.7908 143.956 74.8946 144 74.9955 144C75.0965 144 75.2003 143.959 75.2775 143.878L80.8632 138C81.5963 137.226 82 136.197 82 135.103C82.003 134.009 81.6023 132.981 80.8692 132.207V132.207Z"
                                fill="#9C9C9C"
                            />
                            <rect
                                x="25"
                                y="28"
                                width="100"
                                height="86"
                                rx="5"
                                fill="white"
                            />
                            <rect
                                x="34.4097"
                                y="38"
                                width="21.2668"
                                height="20.8689"
                                rx="1"
                                fill="#CCCCCC"
                            />
                            <rect
                                x="63.5118"
                                y="38"
                                width="21.2668"
                                height="20.8689"
                                rx="1"
                                fill="#CCCCCC"
                            />
                            <rect
                                x="93.7332"
                                y="38"
                                width="21.2668"
                                height="20.8689"
                                rx="1"
                                fill="#CCCCCC"
                            />
                            <rect
                                x="34.4097"
                                y="68.8691"
                                width="49.4262"
                                height="35.1475"
                                rx="1"
                                fill="#F0F0F0"
                            />
                            <path
                                d="M46.1742 83.5575C46.5587 82.8888 47.5235 82.8888 47.908 83.5575L58.8106 102.519C59.1939 103.185 58.7127 104.017 57.9437 104.017H36.1384C35.3694 104.017 34.8882 103.185 35.2715 102.519L46.1742 83.5575Z"
                                fill="#676767"
                            />
                            <path
                                d="M67.045 78.049C67.4303 77.3847 68.3897 77.3847 68.775 78.0491L82.9652 102.515C83.3519 103.182 82.8709 104.017 82.1002 104.017H53.7198C52.9491 104.017 52.4681 103.182 52.8548 102.515L67.045 78.049Z"
                                fill="#676767"
                            />
                            <rect
                                x="99.2129"
                                y="68.9023"
                                width="15.377"
                                height="3.19225"
                                rx="1.59613"
                                fill="#2B2B2B"
                            />
                            <rect
                                x="91.5244"
                                y="75.2871"
                                width="23.0656"
                                height="3.19225"
                                rx="1.59613"
                                fill="#2B2B2B"
                            />
                            <rect
                                x="91.5244"
                                y="81.6709"
                                width="23.0656"
                                height="3.19225"
                                rx="1.59613"
                                fill="#2B2B2B"
                            />
                            <rect
                                x="91.5244"
                                y="88.0557"
                                width="23.0656"
                                height="3.19225"
                                rx="1.59613"
                                fill="#2B2B2B"
                            />
                            <rect
                                x="91.5244"
                                y="94.4404"
                                width="23.0656"
                                height="3.19225"
                                rx="1.59613"
                                fill="#2B2B2B"
                            />
                            <rect
                                x="91.5244"
                                y="100.825"
                                width="15.377"
                                height="3.19225"
                                rx="1.59613"
                                fill="#2B2B2B"
                            />
                            <rect
                                x="109.098"
                                y="100.825"
                                width="5.4918"
                                height="3.19225"
                                rx="1.59613"
                                fill="#2B2B2B"
                            />
                            <rect
                                x="91.5244"
                                y="68.9023"
                                width="5.4918"
                                height="3.19225"
                                rx="1.59613"
                                fill="#2B2B2B"
                            />
                            <rect
                                className="change-hover"
                                x="168.25"
                                y="16.25"
                                width="119.5"
                                height="145.5"
                                rx="6.75"
                                fill="#FFD6E9"
                                stroke="#FF6DB1"
                                strokeWidth="0.5"
                            />
                            <circle
                                className="pre-circle-hover"
                                cx="228"
                                cy="136"
                                r="12"
                                fill="#E32F83"
                            />
                            <path
                                className="hart-hhover"
                                d="M233.869 132.207C233.136 131.433 232.166 131.009 231.13 131.009C230.094 131.009 229.12 131.436 228.387 132.21L228.004 132.614L227.616 132.204C226.883 131.429 225.906 131 224.87 131C223.834 131 222.864 131.426 222.134 132.197C221.401 132.972 220.997 134 221 135.094C221 136.188 221.407 137.213 222.14 137.987L227.714 143.875C227.791 143.956 227.895 144 227.996 144C228.096 144 228.2 143.959 228.278 143.878L233.863 138C234.596 137.226 235 136.197 235 135.103C235.003 134.009 234.602 132.981 233.869 132.207V132.207Z"
                                fill="white"
                            />
                            <rect
                                x="178"
                                y="28"
                                width="100"
                                height="86"
                                rx="5"
                                fill="white"
                            />
                            <rect
                                x="187.41"
                                y="84.1309"
                                width="20.8689"
                                height="20.8689"
                                rx="1"
                                fill="#CCCCCC"
                            />
                            <rect
                                x="215.967"
                                y="84.1309"
                                width="20.8689"
                                height="20.8689"
                                rx="1"
                                fill="#CCCCCC"
                            />
                            <rect
                                x="245.623"
                                y="84.1309"
                                width="20.8689"
                                height="20.8689"
                                rx="1"
                                fill="#CCCCCC"
                            />
                            <rect
                                x="187.41"
                                y="39.0986"
                                width="49.4262"
                                height="35.1475"
                                rx="1"
                                fill="#E9E9E9"
                            />
                            <path
                                d="M199.174 53.787C199.559 53.1183 200.524 53.1183 200.908 53.787L211.811 72.748C212.194 73.4147 211.713 74.2465 210.944 74.2465H189.139C188.37 74.2465 187.888 73.4147 188.272 72.748L199.174 53.787Z"
                                fill="#2B2B2B"
                            />
                            <path
                                d="M220.045 48.2785C220.43 47.6142 221.39 47.6142 221.775 48.2785L235.965 72.7444C236.352 73.4111 235.871 74.2461 235.1 74.2461H206.72C205.949 74.2461 205.468 73.4111 205.855 72.7444L220.045 48.2785Z"
                                fill="#2B2B2B"
                            />
                            <rect
                                x="252.213"
                                y="38"
                                width="15.377"
                                height="3.29508"
                                rx="1.64754"
                                fill="#2B2B2B"
                            />
                            <rect
                                x="244.525"
                                y="44.5898"
                                width="23.0656"
                                height="3.29508"
                                rx="1.64754"
                                fill="#2B2B2B"
                            />
                            <rect
                                x="244.525"
                                y="51.1807"
                                width="23.0656"
                                height="3.29508"
                                rx="1.64754"
                                fill="#2B2B2B"
                            />
                            <rect
                                x="244.525"
                                y="57.7705"
                                width="23.0656"
                                height="3.29508"
                                rx="1.64754"
                                fill="#2B2B2B"
                            />
                            <rect
                                x="244.525"
                                y="64.3604"
                                width="23.0656"
                                height="3.29508"
                                rx="1.64754"
                                fill="#2B2B2B"
                            />
                            <rect
                                x="244.525"
                                y="70.9512"
                                width="15.377"
                                height="3.29508"
                                rx="1.64754"
                                fill="#2B2B2B"
                            />
                            <rect
                                x="262.099"
                                y="70.9512"
                                width="5.4918"
                                height="3.29508"
                                rx="1.64754"
                                fill="#2B2B2B"
                            />
                            <rect
                                x="244.525"
                                y="38"
                                width="5.4918"
                                height="3.29508"
                                rx="1.64754"
                                fill="#2B2B2B"
                            />
                        </svg>
                    )}

                    {title === "Tree test" && (
                        <svg
                            className="tree-test-placeholder"
                            width="304"
                            height="181"
                            viewBox="0 0 304 181"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect
                                x="0.5"
                                y="0.5"
                                width="303"
                                height="180"
                                rx="9.5"
                                fill="white"
                                stroke="#E9E9E9"
                            />
                            <rect
                                x="15"
                                y="16"
                                width="88.4225"
                                height="19.2"
                                rx="3.08451"
                                fill="#E9E9E9"
                            />
                            <rect
                                width="10"
                                height="10"
                                transform="translate(91 31) rotate(-90)"
                                fill="#E9E9E9"
                            />
                            <path
                                d="M94.3333 22.6663L97.6666 25.9997L94.3333 29.333"
                                stroke="black"
                            />
                            <rect
                                className="change-hover"
                                x="15.5141"
                                y="41.7143"
                                width="87.3944"
                                height="18.1718"
                                rx="2.57042"
                                fill="#EFDCFF"
                                stroke="#9759CB"
                                strokeWidth="1.02817"
                            />
                            <path
                                className="back"
                                d="M93.3333 47.8665L96.6666 51.1999L93.3333 54.5332"
                                stroke="black"
                            />
                            <rect
                                x="15"
                                y="66.4004"
                                width="88.4225"
                                height="19.2"
                                rx="3.08451"
                                fill="#E9E9E9"
                            />
                            <rect
                                width="10"
                                height="10"
                                transform="translate(90 81.4004) rotate(-90)"
                                fill="#E9E9E9"
                            />
                            <path
                                d="M93.3333 73.0667L96.6666 76.4001L93.3333 79.7334"
                                stroke="black"
                            />
                            <rect
                                x="15"
                                y="91.5996"
                                width="88.4225"
                                height="19.2"
                                rx="3.08451"
                                fill="#E9E9E9"
                            />
                            <rect
                                width="10"
                                height="10"
                                transform="translate(90 105.6) rotate(-90)"
                                fill="#E9E9E9"
                            />
                            <path
                                d="M93.3333 97.2659L96.6666 100.599L93.3333 103.933"
                                stroke="black"
                            />
                            <rect
                                x="15"
                                y="116.8"
                                width="88.4225"
                                height="19.2"
                                rx="3.08451"
                                fill="#E9E9E9"
                            />
                            <rect
                                width="10"
                                height="10"
                                transform="translate(90 130.8) rotate(-90)"
                                fill="#E9E9E9"
                            />
                            <path
                                d="M93.3333 122.466L96.6666 125.799L93.3333 129.133"
                                stroke="black"
                            />
                            <rect
                                x="15"
                                y="142"
                                width="88.4225"
                                height="19.2"
                                rx="3.08451"
                                fill="#E9E9E9"
                            />
                            <rect
                                width="10"
                                height="10"
                                transform="translate(90 157) rotate(-90)"
                                fill="#E9E9E9"
                            />
                            <path
                                d="M93.3333 148.666L96.6666 152L93.3333 155.333"
                                stroke="black"
                            />
                            <rect
                                x="107"
                                y="38"
                                width="88.4225"
                                height="19.2"
                                rx="3.08451"
                                fill="#E9E9E9"
                            />
                            <rect
                                width="10"
                                height="10"
                                transform="translate(182 53) rotate(-90)"
                                fill="#E9E9E9"
                            />
                            <path
                                d="M185.333 44.6663L188.667 47.9997L185.333 51.333"
                                stroke="black"
                            />
                            <rect
                                x="107"
                                y="63.2002"
                                width="88.4225"
                                height="19.2"
                                rx="3.08451"
                                fill="#E9E9E9"
                            />
                            <rect
                                width="10"
                                height="10"
                                transform="translate(182 78.2002) rotate(-90)"
                                fill="#E9E9E9"
                            />
                            <path
                                d="M185.333 69.8665L188.667 73.1999L185.333 76.5332"
                                stroke="black"
                            />
                            <rect
                                className="change-hover"
                                x="107.514"
                                y="88.9145"
                                width="87.3944"
                                height="18.1718"
                                rx="2.57042"
                                fill="#EFDCFF"
                                stroke="#9759CB"
                                strokeWidth="1.02817"
                            />
                            <path
                                className="back"
                                d="M185.333 95.0667L188.667 98.4001L185.333 101.733"
                                stroke="black"
                            />
                            <rect
                                x="107"
                                y="113.6"
                                width="88.4225"
                                height="19.2"
                                rx="3.08451"
                                fill="#E9E9E9"
                            />
                            <rect
                                width="10"
                                height="10"
                                transform="translate(182 127.6) rotate(-90)"
                                fill="#E9E9E9"
                            />
                            <path
                                d="M185.333 119.266L188.667 122.599L185.333 125.933"
                                stroke="black"
                            />
                            <rect
                                x="200"
                                y="82"
                                width="88.4225"
                                height="19.2"
                                rx="3.08451"
                                fill="#E9E9E9"
                            />
                            <rect
                                x="200"
                                y="107.2"
                                width="88.4225"
                                height="19.2"
                                rx="3.08451"
                                fill="#E9E9E9"
                            />
                            <rect
                                className="change-hover"
                                x="200.514"
                                y="132.914"
                                width="87.3944"
                                height="18.1718"
                                rx="2.57042"
                                fill="#EFDCFF"
                                stroke="#9759CB"
                                strokeWidth="1.02817"
                            />
                        </svg>
                    )}

                    {title === "Survey" && (
                        <>
                            <svg
                                className="survey-placeholder"
                                width="304"
                                height="181"
                                viewBox="0 0 304 181"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect
                                    x="0.5"
                                    y="0.5"
                                    width="303"
                                    height="180"
                                    rx="9.5"
                                    fill="white"
                                    stroke="#E3E3E3"
                                />
                                <rect
                                    x="15"
                                    y="16"
                                    width="273"
                                    height="29"
                                    rx="3.08451"
                                    fill="#F5F5F5"
                                />
                                <rect
                                    x="15"
                                    y="54"
                                    width="181"
                                    height="50"
                                    rx="5.14085"
                                    fill="#F5F5F5"
                                />
                                <rect
                                    x="15.5"
                                    y="112.5"
                                    width="272"
                                    height="49"
                                    rx="4.64085"
                                    fill="#F5F5F5"
                                    stroke="#E9E9E9"
                                />
                                <rect
                                    className="change-hover-2"
                                    x="204.514"
                                    y="54.5141"
                                    width="82.9718"
                                    height="48.9718"
                                    rx="4.62676"
                                    fill="#EFDCFF"
                                    stroke="#9759CB"
                                    strokeWidth="1.02817"
                                    strokeDasharray="2.06 2.06"
                                />
                                <circle
                                    cx="34"
                                    cy="31"
                                    r="7.5"
                                    fill="white"
                                    stroke="#CCCCCC"
                                />
                                <rect
                                    x="48"
                                    y="26.5"
                                    width="51"
                                    height="9"
                                    rx="3.08451"
                                    fill="#9C9C9C"
                                />
                                <circle
                                    cx="124"
                                    cy="31"
                                    r="7.5"
                                    fill="white"
                                    stroke="black"
                                />
                                <circle cx="124" cy="31" r="4" fill="black" />
                                <rect
                                    className="change-hover"
                                    x="138"
                                    y="26.5"
                                    width="51"
                                    height="9"
                                    rx="3.08451"
                                    fill="#9C9C9C"
                                />
                                <circle
                                    cx="214"
                                    cy="31"
                                    r="7.5"
                                    fill="white"
                                    stroke="#CCCCCC"
                                />
                                <rect
                                    x="228"
                                    y="26.5"
                                    width="51"
                                    height="9"
                                    rx="3.08451"
                                    fill="#9C9C9C"
                                />
                                <circle
                                    cx="83.4721"
                                    cy="136.869"
                                    r="13.9721"
                                    fill="white"
                                    stroke="#9C9C9C"
                                />
                                <mask
                                    id="path-14-inside-1_1396_9355"
                                    fill="white"
                                >
                                    <path d="M92.1691 144.365C91.545 142.573 90.3829 141.018 88.8415 139.912C87.3001 138.806 85.4547 138.203 83.5575 138.185C81.6604 138.167 79.8041 138.736 78.2424 139.813C76.6807 140.891 75.4898 142.424 74.8326 144.204L75.5937 144.485C76.193 142.862 77.279 141.464 78.7031 140.481C80.1272 139.499 81.82 138.98 83.55 138.996C85.28 139.012 86.9629 139.562 88.3685 140.571C89.7741 141.58 90.8339 142.998 91.4029 144.632L92.1691 144.365Z" />
                                </mask>
                                <path
                                    d="M92.1691 144.365C91.545 142.573 90.3829 141.018 88.8415 139.912C87.3001 138.806 85.4547 138.203 83.5575 138.185C81.6604 138.167 79.8041 138.736 78.2424 139.813C76.6807 140.891 75.4898 142.424 74.8326 144.204L75.5937 144.485C76.193 142.862 77.279 141.464 78.7031 140.481C80.1272 139.499 81.82 138.98 83.55 138.996C85.28 139.012 86.9629 139.562 88.3685 140.571C89.7741 141.58 90.8339 142.998 91.4029 144.632L92.1691 144.365Z"
                                    stroke="#9C9C9C"
                                    strokeWidth="2"
                                    mask="url(#path-14-inside-1_1396_9355)"
                                />
                                <circle
                                    cx="88.7346"
                                    cy="132.483"
                                    r="1.31564"
                                    fill="#9C9C9C"
                                />
                                <circle
                                    cx="79.0866"
                                    cy="132.483"
                                    r="1.31564"
                                    fill="#9C9C9C"
                                />
                                <circle
                                    cx="152.416"
                                    cy="136.869"
                                    r="13.9721"
                                    fill="white"
                                    stroke="#9C9C9C"
                                />
                                <path
                                    d="M143.207 140.377H161.626"
                                    stroke="#9C9C9C"
                                    strokeLinecap="round"
                                />
                                <circle
                                    cx="157.679"
                                    cy="132.483"
                                    r="1.31564"
                                    fill="#9C9C9C"
                                />
                                <circle
                                    cx="148.031"
                                    cy="132.483"
                                    r="1.31564"
                                    fill="#9C9C9C"
                                />
                                <circle
                                    className="change-hover-3"
                                    cx="221.36"
                                    cy="136.869"
                                    r="13.9721"
                                    fill="white"
                                    stroke="#D7A56A"
                                />
                                <mask
                                    id="path-22-inside-2_1396_9355"
                                    fill="white"
                                >
                                    <path d="M230.57 136.869C230.57 138.078 230.332 139.276 229.869 140.393C229.406 141.51 228.728 142.526 227.872 143.381C227.017 144.236 226.002 144.914 224.885 145.377C223.767 145.84 222.57 146.078 221.36 146.078C220.151 146.078 218.953 145.84 217.836 145.377C216.719 144.914 215.703 144.236 214.848 143.381C213.993 142.526 213.315 141.51 212.852 140.393C212.389 139.276 212.151 138.078 212.151 136.869L221.36 136.869H230.57Z" />
                                </mask>
                                <path
                                    className="change-hover-4"
                                    d="M230.57 136.869C230.57 138.078 230.332 139.276 229.869 140.393C229.406 141.51 228.728 142.526 227.872 143.381C227.017 144.236 226.002 144.914 224.885 145.377C223.767 145.84 222.57 146.078 221.36 146.078C220.151 146.078 218.953 145.84 217.836 145.377C216.719 144.914 215.703 144.236 214.848 143.381C213.993 142.526 213.315 141.51 212.852 140.393C212.389 139.276 212.151 138.078 212.151 136.869L221.36 136.869H230.57Z"
                                    stroke="#D7A56A"
                                    strokeWidth="2"
                                    mask="url(#path-22-inside-2_1396_9355)"
                                />
                                <circle
                                    className="change-eye"
                                    cx="226.623"
                                    cy="132.483"
                                    r="1.31564"
                                    fill="#D7A56A"
                                />
                                <circle
                                    className="change-eye"
                                    cx="216.975"
                                    cy="132.483"
                                    r="1.31564"
                                    fill="#D7A56A"
                                />
                            </svg>
                        </>
                    )}

                    {title === "5 second test" && (
                        <svg
                            className="five-second-placeholder"
                            width="304"
                            height="181"
                            viewBox="0 0 304 181"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect
                                x="0.5"
                                y="0.5"
                                width="303"
                                height="180"
                                rx="9.5"
                                fill="white"
                                stroke="#E3E3E3"
                            />
                            <rect
                                x="15"
                                y="16"
                                width="273"
                                height="146"
                                rx="3.08451"
                                fill="#F5F5F5"
                            />
                            <path
                                className="change-hover"
                                d="M87.18 96.42C92.04 96.42 95.28 93.36 95.28 88.8C95.28 84.18 92.19 81.12 87.54 81.12C86.1 81.12 84.33 81.72 83.13 82.62L83.64 78.6H94.14V75.42H80.7L79.38 86.16L82.65 86.58C83.37 85.2 84.96 84.3 86.67 84.3C89.7 84.3 91.71 86.1 91.71 88.83C91.71 91.8 89.4 93.24 87.09 93.24C84.36 93.24 82.5 91.5 82.38 88.92H79.08C79.08 93.72 82.32 96.42 87.18 96.42ZM112.838 96.42C118.328 96.42 121.988 93.84 121.988 90C121.988 82.47 108.578 84.24 108.578 81.06C108.578 79.59 110.288 78.6 112.838 78.6C115.238 78.6 117.158 79.89 117.638 81.84L121.328 80.91C120.368 77.37 116.978 75 112.838 75C107.888 75 104.588 77.43 104.588 81.06C104.588 88.35 117.998 85.8 117.998 90C117.998 91.68 115.928 92.82 112.838 92.82C109.568 92.82 107.348 91.26 107.258 88.92H103.448C103.538 93.42 107.288 96.42 112.838 96.42ZM131.383 96.42C135.043 96.42 138.163 94.2 139.153 90.9H135.493C134.803 92.4 133.153 93.42 131.383 93.42C129.043 93.42 127.243 91.86 126.913 89.49H139.213L139.513 89.19V88.5C139.513 83.76 136.273 80.58 131.383 80.58C126.493 80.58 123.253 83.76 123.253 88.5C123.253 93.24 126.493 96.42 131.383 96.42ZM127.153 86.49C127.843 84.63 129.373 83.58 131.383 83.58C133.393 83.58 134.923 84.63 135.613 86.49H127.153ZM149.195 96.42C153.275 96.42 156.425 93.81 157.055 89.91H153.605C153.155 91.92 151.385 93.24 149.195 93.24C146.465 93.24 144.665 91.35 144.665 88.5C144.665 85.65 146.465 83.76 149.195 83.76C151.355 83.76 153.095 85.02 153.575 86.94H157.025C156.365 83.13 153.245 80.58 149.195 80.58C144.305 80.58 141.065 83.76 141.065 88.5C141.065 93.24 144.305 96.42 149.195 96.42ZM166.744 96.42C171.634 96.42 174.874 93.24 174.874 88.5C174.874 83.76 171.634 80.58 166.744 80.58C161.854 80.58 158.614 83.76 158.614 88.5C158.614 93.24 161.854 96.42 166.744 96.42ZM166.744 93.24C164.014 93.24 162.214 91.35 162.214 88.5C162.214 85.65 164.014 83.76 166.744 83.76C169.474 83.76 171.274 85.65 171.274 88.5C171.274 91.35 169.474 93.24 166.744 93.24ZM176.734 96H180.334V87.09C180.334 85.08 181.804 83.76 183.994 83.76C186.184 83.76 187.654 85.08 187.654 87.09V96H191.254V86.67C191.254 83.01 188.524 80.58 184.414 80.58C182.944 80.58 181.324 81.18 180.334 82.11V81H176.734V96ZM201.046 96.42C202.876 96.42 204.886 95.58 206.026 94.35V96H209.626V75.42H206.026V82.65C204.886 81.42 202.876 80.58 201.046 80.58C196.306 80.58 193.126 83.76 193.126 88.5C193.126 93.24 196.306 96.42 201.046 96.42ZM201.406 93.24C198.586 93.24 196.726 91.35 196.726 88.5C196.726 85.65 198.586 83.76 201.406 83.76C204.166 83.76 206.026 85.65 206.026 88.5C206.026 91.35 204.166 93.24 201.406 93.24ZM218.455 96.42C222.625 96.42 225.415 94.44 225.415 91.47C225.415 88.74 223.825 87.6 218.815 86.55C216.685 86.07 215.995 85.68 215.995 85.05C215.995 84.18 216.985 83.58 218.455 83.58C219.775 83.58 220.975 84.27 221.425 85.29L224.725 84.48C223.855 82.14 221.335 80.58 218.455 80.58C214.825 80.58 212.395 82.44 212.395 85.23C212.395 87.72 213.775 88.71 218.125 89.7C220.915 90.24 221.815 90.75 221.815 91.47C221.815 92.64 220.465 93.42 218.455 93.42C216.445 93.42 215.005 92.4 214.885 90.9H211.495C211.615 94.2 214.405 96.42 218.455 96.42Z"
                                fill="#FF6DB1"
                            />
                        </svg>
                    )}

                    {title === "First click" && (
                        <svg
                            className="first-click-placeholder"
                            width="304"
                            height="181"
                            viewBox="0 0 304 181"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect
                                x="0.5"
                                y="0.5"
                                width="303"
                                height="180"
                                rx="9.5"
                                fill="white"
                                stroke="#E3E3E3"
                            />
                            <rect
                                x="15"
                                y="54"
                                width="88"
                                height="108"
                                rx="3.08451"
                                fill="#CCCCCC"
                            />
                            <rect
                                x="15"
                                y="16"
                                width="273"
                                height="24"
                                rx="3.08451"
                                fill="#9C9C9C"
                            />
                            <rect
                                x="112"
                                y="112"
                                width="84"
                                height="50"
                                rx="5.14085"
                                fill="#F0F0F0"
                            />
                            <rect
                                x="112"
                                y="54"
                                width="84"
                                height="50"
                                rx="5.14085"
                                fill="#F0F0F0"
                            />
                            <rect
                                x="204"
                                y="112"
                                width="84"
                                height="50"
                                rx="5.14085"
                                fill="#F0F0F0"
                            />
                            <rect
                                className="change-hover"
                                x="204.514"
                                y="54.5141"
                                width="82.9718"
                                height="48.9718"
                                rx="4.62676"
                                fill="#EFDCFF"
                                stroke="#9759CB"
                                strokeWidth="1.02817"
                                strokeDasharray="2.06 2.06"
                            />
                            <path
                                d="M240.19 105.411L238.096 97.5917M235.5 75.4688V78.9375M244.494 79.1934L242.041 81.6462M248.219 88.1875H244.75M228.959 94.7288L226.507 97.18M226.25 88.1875H222.781M228.959 81.6462L226.507 79.195M238.096 97.5917L234.227 101.022L235.104 86.4223L243.162 98.6277L238.096 97.5917Z"
                                stroke="black"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    )}
                    {title === "Prototype" && (
                        <svg
                            width="304"
                            height="181"
                            className="prototype-test-placeholder"
                            viewBox="0 0 304 181"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect
                                x="0.5"
                                y="0.5"
                                width="303"
                                height="180"
                                rx="9.5"
                                fill="white"
                                stroke="#E3E3E3"
                            />

                            <rect
                                x="15"
                                y="16"
                                width="273"
                                height="146"
                                rx="3.08451"
                                fill="#F5F5F5"
                            />
                            <rect
                                x="26"
                                y="31"
                                width="75"
                                height="117"
                                rx="5.14085"
                                fill="#CCCCCC"
                            />
                            <rect
                                x="36.5"
                                y="92.5"
                                width="54"
                                height="14"
                                rx="1.5"
                                fill="#E9E9E9"
                                stroke="#FF6DB1"
                            />
                            <rect
                                x="36"
                                y="42"
                                width="55"
                                height="37"
                                rx="2"
                                fill="#E9E9E9"
                            />
                            <g clipPath="url(#clip0_14215_37321)">
                                <path
                                    d="M63.7709 60.9987C63.7709 60.0262 64.1572 59.0936 64.8448 58.406C65.5324 57.7183 66.4651 57.332 67.4375 57.332C68.41 57.332 69.3426 57.7183 70.0303 58.406C70.7179 59.0936 71.1042 60.0262 71.1042 60.9987C71.1042 61.9712 70.7179 62.9038 70.0303 63.5914C69.3426 64.2791 68.41 64.6654 67.4375 64.6654C66.4651 64.6654 65.5324 64.2791 64.8448 63.5914C64.1572 62.9038 63.7709 61.9712 63.7709 60.9987Z"
                                    fill="#1ABCFE"
                                />
                                <path
                                    d="M56.4375 68.3346C56.4375 67.3622 56.8238 66.4295 57.5114 65.7419C58.1991 65.0543 59.1317 64.668 60.1042 64.668H63.7708V68.3346C63.7708 69.3071 63.3845 70.2397 62.6969 70.9274C62.0093 71.615 61.0766 72.0013 60.1042 72.0013C59.1317 72.0013 58.1991 71.615 57.5114 70.9274C56.8238 70.2397 56.4375 69.3071 56.4375 68.3346V68.3346Z"
                                    fill="#0ACF83"
                                />
                                <path
                                    d="M63.7709 50V57.3333H67.4375C68.41 57.3333 69.3426 56.947 70.0303 56.2594C70.7179 55.5718 71.1042 54.6391 71.1042 53.6667C71.1042 52.6942 70.7179 51.7616 70.0303 51.0739C69.3426 50.3863 68.41 50 67.4375 50H63.7709Z"
                                    fill="#FF7262"
                                />
                                <path
                                    d="M56.4375 53.6667C56.4375 54.6391 56.8238 55.5718 57.5114 56.2594C58.1991 56.947 59.1317 57.3333 60.1042 57.3333H63.7708V50H60.1042C59.1317 50 58.1991 50.3863 57.5114 51.0739C56.8238 51.7616 56.4375 52.6942 56.4375 53.6667V53.6667Z"
                                    fill="#F24E1E"
                                />
                                <path
                                    d="M56.4375 60.9987C56.4375 61.9712 56.8238 62.9038 57.5114 63.5914C58.1991 64.2791 59.1317 64.6654 60.1042 64.6654H63.7708V57.332H60.1042C59.1317 57.332 58.1991 57.7183 57.5114 58.406C56.8238 59.0936 56.4375 60.0262 56.4375 60.9987V60.9987Z"
                                    fill="#A259FF"
                                />
                            </g>
                            <rect
                                x="36.5"
                                y="117.5"
                                width="54"
                                height="14"
                                rx="1.5"
                                fill="#E9E9E9"
                                stroke="#9759CB"
                            />
                            <rect
                                x="114.5"
                                y="31.5"
                                width="74"
                                height="116"
                                rx="4.64085"
                                fill="#CCCCCC"
                                stroke="#676767"
                                className="change-hover-pink"
                            />
                            <rect
                                x="202.5"
                                y="31.5"
                                width="74"
                                height="116"
                                rx="4.64085"
                                fill="#CCCCCC"
                                stroke="#676767"
                                className="change-hover-purpl"
                            />
                            <path
                                d="M113.854 100.354C114.049 100.158 114.049 99.8417 113.854 99.6464L110.672 96.4645C110.476 96.2692 110.16 96.2692 109.964 96.4645C109.769 96.6597 109.769 96.9763 109.964 97.1716L112.793 100L109.964 102.828C109.769 103.024 109.769 103.34 109.964 103.536C110.16 103.731 110.476 103.731 110.672 103.536L113.854 100.354ZM90.5 100.5H113.5V99.5H90.5V100.5Z"
                                fill="#676767"
                                className="change-hover-arrow-purpl"
                            />
                            <path
                                d="M201.994 107.076C202.036 106.803 201.849 106.548 201.576 106.506L197.129 105.819C196.856 105.777 196.601 105.964 196.559 106.237C196.516 106.51 196.704 106.765 196.976 106.807L200.93 107.418L200.319 111.371C200.277 111.644 200.464 111.899 200.737 111.941C201.01 111.984 201.265 111.796 201.307 111.524L201.994 107.076ZM90.7982 124.957C102.242 130.006 121.091 132.128 141.495 129.747C161.912 127.364 183.958 120.467 201.795 107.403L201.205 106.597C183.542 119.533 161.672 126.386 141.38 128.753C121.076 131.122 102.425 128.994 91.2018 124.043L90.7982 124.957Z"
                                fill="#676767"
                                className="change-hover-arrow-purpl"
                            />
                            <defs>
                                <clipPath id="clip0_14215_37321">
                                    <rect
                                        width="22"
                                        height="22"
                                        fill="white"
                                        transform="translate(53 50)"
                                    />
                                </clipPath>
                            </defs>
                        </svg>
                    )}
                    {title === "Custom recruitment" && (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="228"
                            height="136"
                            viewBox="0 0 228 136"
                            fill="none"
                            className="recruitment-placeholder"
                        >
                            <rect
                                x="1.25689"
                                y="1.25689"
                                width="225.506"
                                height="133.964"
                                rx="7.07031"
                                fill="white"
                                stroke="#E3E3E3"
                                strokeWidth="0.744243"
                            />
                            <path
                                className="change-hover-yellow"
                                d="M127.914 54.5744C127.951 54.4785 128.015 54.3964 128.097 54.3386C128.179 54.2808 128.276 54.25 128.375 54.25C128.474 54.25 128.571 54.2808 128.653 54.3386C128.735 54.3964 128.799 54.4785 128.836 54.5744L130.722 59.3278C130.757 59.4168 130.815 59.4938 130.89 59.5504C130.964 59.607 131.052 59.641 131.144 59.6487L136.04 60.0598C136.483 60.097 136.662 60.6764 136.325 60.9786L132.594 64.3286C132.525 64.3911 132.473 64.4725 132.444 64.5639C132.416 64.6552 132.412 64.7531 132.433 64.8466L133.573 69.8549C133.596 69.9553 133.59 70.0607 133.556 70.1576C133.522 70.2545 133.461 70.3386 133.381 70.3993C133.301 70.46 133.206 70.4946 133.108 70.4987C133.009 70.5027 132.912 70.4761 132.828 70.4222L128.635 67.739C128.557 67.6889 128.467 67.6624 128.375 67.6624C128.283 67.6624 128.193 67.6889 128.115 67.739L123.922 70.4231C123.838 70.4771 123.741 70.5037 123.642 70.4996C123.544 70.4955 123.449 70.461 123.369 70.4002C123.289 70.3395 123.228 70.2554 123.194 70.1585C123.16 70.0616 123.154 69.9563 123.177 69.8558L124.317 64.8466C124.338 64.7531 124.334 64.6552 124.306 64.5638C124.277 64.4724 124.225 64.391 124.156 64.3286L120.425 60.9786C120.35 60.9115 120.296 60.8225 120.269 60.723C120.242 60.6234 120.244 60.5177 120.274 60.4194C120.305 60.321 120.363 60.2343 120.44 60.1702C120.518 60.1062 120.612 60.0678 120.71 60.0598L125.606 59.6487C125.698 59.641 125.786 59.607 125.86 59.5504C125.935 59.4938 125.993 59.4168 126.028 59.3278L127.914 54.5744Z"
                                fill="#fff"
                                stroke="black"
                                strokeWidth="1.8"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                className="change-hover-pink"
                                d="M114.962 56.4615C114.962 58.3741 114.202 60.2084 112.849 61.5608C111.497 62.9133 109.663 63.6731 107.75 63.6731C105.837 63.6731 104.003 62.9133 102.651 61.5608C101.298 60.2084 100.538 58.3741 100.538 56.4615C100.538 54.5489 101.298 52.7146 102.651 51.3622C104.003 50.0098 105.837 49.25 107.75 49.25C109.663 49.25 111.497 50.0098 112.849 51.3622C114.202 52.7146 114.962 54.5489 114.962 56.4615ZM93.3289 83.6115C93.3907 79.8275 94.9372 76.2195 97.635 73.5654C100.333 70.9114 103.966 69.4239 107.75 69.4239C111.534 69.4239 115.167 70.9114 117.865 73.5654C120.563 76.2195 122.109 79.8275 122.171 83.6115C117.647 85.686 112.727 86.7567 107.75 86.7499C102.604 86.7499 97.7192 85.6269 93.3289 83.6115Z"
                                fill="#fff"
                                stroke="black"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    )}
                    {/*{isComingSoon && (title!="Prototype" || title!="First click") &&*/}
                    {/*<div className="test-coming-soon"><Tag title={"Coming soon"} /></div>*/}
                    {/*}*/}
                </div>

                <div className="test-card-info">
                    <h4
                        className={` d-flex justify-content-between align-items-center ${
                            isComingSoon ? " first-click-heading" : ""
                        }`}
                    >
                        <div
                            className={` ${
                                isAIActive ? " d-flex align-items-center" : ""
                            }`}
                        >
                            <Text
                                type="subtitle-2"
                                children={title}
                                fontWeight="semi-bold-font"
                            />
                            {isInfo && (
                                <span className="info-wrap">
                                    <Icon
                                        size={"medium"}
                                        value={"information"}
                                    />
                                    <div className="tooltip-wrapper bottom-tooltip">
                                        <Text
                                            type="body-text-2"
                                            id="tooltip"
                                            children={description}
                                            fontWeight="normal-font"
                                        />
                                    </div>
                                </span>
                            )}

                            {isAIActive && (
                                <div className="Ai_lottie-hold ml-2 Ai_icon position-relative">
                                    <div
                                        className=""
                                        id="svg"
                                        ref={svgContainer1}
                                        style={{ width: 32, height: 32 }}
                                    ></div>
                                    <Tooltip
                                        className="tooltip-hold"
                                        data="Powered by AI"
                                        type="bottom"
                                    />
                                </div>
                            )}
                        </div>

                        {publishing_credits !== 0 && publishing_credits > 0 ? (
                            <>
                                <Text
                                    type={"body-text-3"}
                                    cssClasses={"black-color"}
                                    fontWeight={"semibold-font"}
                                >
                                    {" "}
                                    <Icon
                                        value={"credit"}
                                        size={"small"}
                                    />{" "}
                                    {publishing_credits}{" "}
                                    <span className="credits-text">
                                        credits
                                    </span>
                                </Text>
                            </>
                        ) : (
                            
                            <>
                                {title !== "Custom recruitment" &&
                                <Text
                                    type={"body-text-3"}
                                    cssClasses={"pink-color"}
                                    fontWeight={"semibold-font"}
                                >
                                    Free
                                </Text>
                                }
                            </>
                            )
                            
                        }
                        {isComingSoon &&
                            (title == "Prototype" ||
                                title == "First click") && (
                                <Text
                                    type="subtitle-2"
                                    cssClasses={`${
                                        title == "Prototype" ||
                                        title == "First click"
                                            ? "purple-bg-fill"
                                            : ""
                                    }`}
                                    children={
                                        title == "Prototype" ||
                                        title == "First click"
                                            ? "New"
                                            : "Coming soon"
                                    }
                                    fontWeight="tag"
                                />
                            )}
                    </h4>

                    {!isInfo && (
                        <Text
                            type="body-text-3"
                            children={description}
                            fontWeight="normal-font"
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

Defaultcard.propTypes = {
    isInfo: PropTypes.bool,
    isComingSoon: PropTypes.bool,
    title: PropTypes.string,
    description: PropTypes.string,
};
